export default "__VITE_ASSET__Fn0pQJNH__"